import { ReactNode } from "react";

export function SectionHeading({
  index,
  children,
  size = "clamp(30px,5vw,52px)",
  withRule = true,
}: {
  index: string;
  children: ReactNode;
  size?: string;
  withRule?: boolean;
}) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "baseline",
        gap: 14,
        marginBottom: 26,
      }}
    >
      <span
        style={{
          fontFamily: "'Archivo Black',sans-serif",
          fontSize: 14,
          color: "var(--accent)",
        }}
      >
        {index}
      </span>
      <h2
        style={{
          margin: 0,
          fontFamily: "'Archivo Black',sans-serif",
          fontSize: size,
          letterSpacing: "-0.03em",
          textTransform: "uppercase",
        }}
      >
        {children}
      </h2>
      {withRule && (
        <div style={{ flex: 1, height: 3, background: "var(--fg)" }} />
      )}
    </div>
  );
}
